import React, { useRef } from 'react';
var VeltNotificationsPanelHeaderTabPeople = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-header-tab-people", { ref: ref }, children));
};
export default VeltNotificationsPanelHeaderTabPeople;
